import React, { ReactNode } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

interface InfinityListProps {
  hasMore?: boolean;
  next: () => void;
  loader?: ReactNode;
  endMessage?: ReactNode;
  children: ReactNode;
  dataLength?: number;
  height?: number | string;
}

export const InfinityList: React.FC<InfinityListProps> = ({
  hasMore = false,
  next,
  loader,
  endMessage,
  children,
  dataLength = 0,
  height = '445px',
}) => {
  return (
    <InfiniteScroll
      hasMore={hasMore}
      next={next}
      loader={loader}
      endMessage={endMessage}
      dataLength={dataLength}
      height={height}
    >
      {children}
    </InfiniteScroll>
  );
};
